import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "count",
    "periodicitySection"
  ]

  connect() {
    this.update()
  }

  update() {
    const count = parseInt(this.countTarget.value || "1", 10)

    console.log("instalments: count:", count)

    this.periodicitySectionTarget.classList.toggle(
      "d-none",
      count <= 1
    )
  }
}